import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { CallParkingLotRegister } from '../call-parkinglot-register';
import { CallParkingLotFilterOptions } from '../models/call-parking-filter-option';

import { map } from 'rxjs/operators';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { CallParkingLotRegisterListItem } from '../models/call-parkinglot-register-results.model';
import * as CallLogsActions from '../state/call-parkinglot-register.actions';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-call-parkinglot-register',
    templateUrl: './call-parkinglot-register.component.html',
    standalone: false
})
export class CallParkingLotRegisterComponent extends CallParkingLotRegister {
   @Input() get accountId(): number {
      return this._accountId;
   }

   set accountId(value: number) {
      this._accountId = value;
      this.filters = this.buildFilters();
   }

   @Output() filtersChanged = new EventEmitter<CallParkingLotFilterOptions[]>();

   private _accountId: number;

   constructor(public store: Store) {
      super(store);
      this.columns = ['callerIdInformation', 'parkingSlotNumber', 'parkerExtension', 'parkDateTime'];
      store
         .pipe(
            map(() => {
               const filters: CallParkingLotFilterOptions[] = [
                  {
                     field: 'ParkerExtension.AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: this.accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
   }

   onOpenDialog(event: { callLogs: CallParkingLotRegisterListItem }) {
      this.store.dispatch(CallLogsActions.openDialog(event));
   }

   onListen(event: Array<FileOption>) {
      this.store.dispatch(CallLogsActions.listenToRecording({ files: event }));
   }

   private buildFilters(): CallParkingLotFilterOptions[] {
      const filters: CallParkingLotFilterOptions[] = [
         {
            field: 'ParkerExtension.AccountId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: this.accountId,
         },
      ];

      return filters;
   }
}
